var map = {
	"./Alkhalil-white.png": "7e22",
	"./Alkhalil.png": "0bd4",
	"./Asia.png": "7ce4",
	"./AsiaBlue.png": "602f",
	"./OctopharmaLogo.png": "41d7",
	"./Untitled-1.png": "1d6c",
	"./Untitled.png": "02b0",
	"./brands/Barakat-h.png": "8c58",
	"./brands/Barakat-w.png": "1bda",
	"./brands/Barakat-white.png": "ca1b",
	"./brands/OUBARI.png": "34da",
	"./brands/Oulabi.png": "b881",
	"./brands/Untitled-1.png": "024c",
	"./brands/Untitled-alkhalil.png": "b7f7",
	"./brands/golden-pharma-white.png": "e08c",
	"./brands/golden-pharma.png": "078c",
	"./brands/ibn-alhaythem-mini.png": "b357",
	"./brands/ibn-alhaythem.png": "959e",
	"./brands/land-location-alkhalil.png": "4546",
	"./brands/logo-eng (2).png": "d4e2",
	"./brands/logo-full-white.png": "8c4f4",
	"./brands/logo-full.png": "d7d8",
	"./brands/mirta-logo-white.png": "5c4b",
	"./brands/mirta-logo.png": "1c0a",
	"./brands/mirta.png": "a8c4",
	"./brands/oulabi-white.png": "1735",
	"./facebook.png": "5307",
	"./gmail.png": "0f48",
	"./ima.png": "2936",
	"./images.png": "30f9",
	"./instagram.png": "c7f8",
	"./jobIcon.png": "8785",
	"./jobPositionIcon.png": "509d",
	"./landline.png": "4761",
	"./linkedIn.png": "4d38",
	"./location.png": "e6b6",
	"./logo vue.png": "dc37",
	"./logo-eng (2).png": "833e",
	"./logo-full-white.png": "047f",
	"./logo-full.png": "75609",
	"./logo-white.png": "d939",
	"./logo0.png": "a486",
	"./phone.png": "3547",
	"./photo_2023-08-31_17-32-55.png": "6812",
	"./photo_2023-08-31_17-34-48.png": "1b1c",
	"./placeholderProduct.png": "bb14",
	"./pngwing-brown (16).png": "ba5c",
	"./pngwing.com (16).png": "ff9e",
	"./sidebar-icons/blood-sample.png": "5630",
	"./sidebar-icons/calendar (1).png": "4f23",
	"./sidebar-icons/calendar.png": "0f41",
	"./sidebar-icons/clipboard.png": "68a0",
	"./sidebar-icons/credit.png": "b4eb",
	"./sidebar-icons/delivery (1).png": "095b",
	"./sidebar-icons/exam.png": "abef",
	"./sidebar-icons/group.png": "c23f",
	"./sidebar-icons/money.png": "b026",
	"./sidebar-icons/option2.png": "a55a",
	"./sidebar-icons/pie-chart.png": "a63e",
	"./sidebar-icons/report.png": "ac98",
	"./sidebar-icons/setting.png": "aa84",
	"./sidebar-icons/suitcase.png": "e55f",
	"./smile_742751.png": "7b3d",
	"./telegram.png": "c2ea",
	"./twitter.png": "e4d7",
	"./web.png": "edbf",
	"./whatsapp.png": "9673",
	"./white-logo-golden-pharma.png": "89cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";